import cx from 'classnames';
import { useFieldIfAvailable } from "../../../core/useFieldIfAvailable";
import { useCallback } from 'react';
import { Box, Button, ButtonGroup, FormGroup, Input } from 'tombac';
import { AddIcon, SubtractIcon } from 'tombac-icons';
import CountLimitSummary from "../limit-summaries/CountLimitSummary";
import { SharedLimitWarning } from "./limitEditorElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CountLimitEditor({
  className,
  defaultLimit = null,
  isSharedLimit = false,
  isSharedWithOther = false,
  label,
  limit = null,
  onChange,
  schema
}) {
  const [field,, helpers] = useFieldIfAvailable(schema.name);
  if (field) {
    limit = field.value ?? null;
    onChange = helpers.setValue;
  }
  const handleChange = useCallback(event => {
    let newLimit = null;
    if (event.target.value.trim() !== '') {
      newLimit = Number(event.target.value);
      newLimit = Number.isNaN(newLimit) ? limit : Math.abs(Math.floor(newLimit));
    }
    if (onChange) {
      onChange(newLimit);
    }
  }, [onChange]);
  const placeholder = defaultLimit !== null ? defaultLimit.toString() : isSharedLimit ? schema.required ? '' : 'Use product limit' : 'Unlimited';
  return /*#__PURE__*/_jsx(FormGroup, {
    className: cx('CountLimitEditor', className),
    htmlFor: `input-${schema?.name}`,
    label: label,
    $width: "100%",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "CountLimitEditor",
    "data-sentry-source-file": "CountLimitEditor.tsx",
    children: schema.customizable ? /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      children: [/*#__PURE__*/_jsx(Input, {
        $flex: "auto",
        disabled: isSharedWithOther,
        id: `input-${schema?.name}`,
        name: field?.name,
        onBlur: field?.onBlur,
        onChange: handleChange,
        placeholder: placeholder,
        type: "text",
        value: limit === null ? '' : limit.toString(),
        $width: "100%"
      }), isSharedWithOther ? /*#__PURE__*/_jsx(SharedLimitWarning, {}) : /*#__PURE__*/_jsxs(ButtonGroup, {
        className: "CountLimitEditor__button-group",
        $ml: "2sp",
        children: [/*#__PURE__*/_jsx(Button, {
          className: "CountLimitEditor__button",
          onClick: () => onChange(limit > 0 ? limit - 1 : 0),
          shape: "circle",
          type: "button",
          children: /*#__PURE__*/_jsx(SubtractIcon, {})
        }), /*#__PURE__*/_jsx(Button, {
          $ml: "0.5sp",
          className: "CountLimitEditor__button",
          onClick: () => onChange(limit + 1),
          shape: "circle",
          type: "button",
          children: /*#__PURE__*/_jsx(AddIcon, {})
        })]
      })]
    }) : limit !== null ? /*#__PURE__*/_jsx(CountLimitSummary, {
      className: "LimitEditor__value",
      limit: limit,
      schema: schema,
      variant: "basic"
    }) : /*#__PURE__*/_jsx("span", {
      className: "LimitEditor__value",
      children: placeholder
    })
  });
}